export const APP_CONFIG = {
  MAX_LIVES_STANDARD: 3,
  ANIMATION_DURATION: 0.3,
  FLAG_BASE_URL: 'https://flagcdn.com',
  QUESTION_COOLDOWN_COUNT: 10,
};

// Common aliases map to help search normalization
// In a real build, this would be generated from a larger dataset
export const ALIAS_MAP: Record<string, string> = {
  'usa': 'USA',
  'uk': 'GBR',
  'uae': 'ARE',
  'drc': 'COD',
  'car': 'CAF',
  'svg': 'VCT',
  'sk': 'KOR',
  'nk': 'PRK',
  'nz': 'NZL',
  'rsa': 'ZAF',
};
